<template>
    <div class="lb-main-layout is-centered">
        <div class="lb-content">
            <session-join-modal v-if="!session && !showQuiz" />
            <project-modal-resume
                v-else-if="!showQuiz"
                :project-source="session.project"
                @close="$router.push('dashboard')"
            >
                <template #navigationButtons>
                    <div v-if="!showAlias" class="buttons is-centered">
                        <div
                            v-if="canResetSession"
                            class="notification is-warning"
                            v-html="$t('reset_session_desc')"
                        ></div>
                        <button
                            v-if="canResetSession"
                            v-t="'Buttons.reset_session'"
                            class="button is-primary is-inverted has-text-weight-bold"
                            @click="resetSession"
                        ></button>

                        <button
                            v-if="canPlay"
                            v-t="'Buttons.play'"
                            class="button is-primary has-text-weight-bold"
                            @click="goPlay"
                        ></button>
                        <div
                            v-if="!canPlay && !canResetSession && !session.configuration.app"
                            class="has-text-centered py-4"
                        >
                            <p v-t="'Sessions.STATUS_COMPLETED'" class="tag is-success"></p>
                            <p v-t="'Sessions.STATUS_COMPLETED_DESCRIPTION'"></p>
                        </div>
                        <div
                            v-if="session.configuration.app"
                            class="notification is-warning"
                            v-html="$t('Sessions.app_mode_hint')"
                        ></div>
                    </div>
                    <div v-if="showAlias" class="py-5">
                        <div>
                            <div class="columns is-centered">
                                <div class="field">
                                    <div class="field has-addons">
                                        <div class="control">
                                            <input
                                                v-model="userProfile.alias"
                                                class="input"
                                                type="text"
                                                :placeholder="$t('Sessions.add_alias')"
                                            />
                                        </div>
                                        <div class="control">
                                            <a
                                                class="button is-primary"
                                                v-t="'Buttons.add_alias'"
                                                @click="addAlias"
                                            ></a>
                                        </div>
                                    </div>
                                    <label
                                        class="label is-6 has-text-black"
                                        v-t="'Sessions.add_alias'"
                                    ></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </project-modal-resume>
            <component :is="playground" v-else />
        </div>
    </div>
</template>

<script>
import PlayTreasureHunt from '@/components/PlayTreasureHunt';
import PlayQuiz from '@/components/PlayQuiz';
import SessionJoinModal from '@/components/SessionJoinModal';
import ProjectModalResume from '@/components/ProjectModalResume';
import _ from 'underscore';
import PlayGeoQuiz from '@/components/PlayGeoQuiz';

export default {
    components: {
        SessionJoinModal,
        PlayQuiz,
        ProjectModalResume,
    },
    data() {
        return {
            showQuiz: false,
            showAlias: false,
            anonymousPlay: false,
            userProfile: {},
        };
    },
    computed: {
        playground() {
            if (this.session.project.type == 'treasurehunt') {
                return PlayTreasureHunt;
            } else if(this.session.project.type == 'trivial' && this.session.project.mode == 'map'){
                return PlayGeoQuiz;
            }else{
                return PlayQuiz;
            }
        },
        session() {
            return this.$store.state.session;
        },
        canResetSession() {
            return (
                this.session.allowsReset &&
                !!this.session.session_answers.length
            );
        },
        canPlay() {
            return (
                this.session.session_answers.length !=
                this.session.context.length &&
                !this.session.configuration.app
            );
        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        userProfileData(){
            return this.$store.getters.user;
        },
        personalData() {
            return this.$store.getters.personalData;
        },
        personalDataChanged() {
            return !_.isEqual(this.userProfile, this.$store.getters.personalData);
        },
    },
    beforeDestroy() {
        this.$store.dispatch('cleanSession');
    },
    mounted(){
        //console.log('in play mounted',this.isLoggedIn)
        if(this.isLoggedIn){
            //saving alias
            if(this.userProfile.alias){
                let oldData={...this.userProfile};
            }
            
            //console.log("old User",oldData)
            this.$store.dispatch('logout').then(() => {
            this.$store.dispatch('anonymousLogin').then(() => {
                //console.log("new User",this.userProfile)
                if(oldData.alias){
                    this.userProfile.alias = oldData.alias;
                }
            });
        });
            

        }
    },
    methods: {
        resetSession() {
            console.log('reseting session');
            this.$store.dispatch('resetSession');
        },
        goPlay(){
            if(!this.isAnonymous){
                this.showQuiz = true;
            }else{
                this.showAlias = true;
            }
        },
        addAlias(){
            if(!this.userProfile.alias){
                return;
            }
            if(this.personalDataChanged){
                console.log('sending alias')
                this.$store.dispatch('updateProfile', this.userProfile);
            }
            this.hasAlias=true;
            this.showQuiz = true;
            
        },
    },
     watch: {
        personalData: {
            handler: function () {
                this.loadingData = false;
                this.userProfile = JSON.parse(
                    JSON.stringify(this.$store.getters.personalData)
                );
            },
            immediate: true,
        },
    },
};
</script>

<style scoped></style>